<!--<script src="../../../../../Desktop/領澳/汇业新/router/index.js"></script>-->
<!--<script src="../../../../../Desktop/領澳/汇业新/main.js"></script>-->
<template>
    <transiton name="fade">
        <div class="container col-xs-12" v-if="showAlert">
            <div class="popup">
                <div class="title clearfix">
                    <span >投票驗證</span>
                    <a @click="colse">×</a>
                </div>
                <!--<div class="clear"></div>-->
                <!--<hr >-->
                <form class="form" @submit.prevent="check">
                  <h4 :style="{color: isError ? 'red':''}">{{tips}}</h4>
                  <div class="one-line"><span class="email-line">電郵</span><input required v-model="inputData.email" type="text" class="email-input"></div>
                  <div class="one-line"><span class="code-line">驗證碼</span><input required v-model="inputData.code" type="text" class="code-input">
                  <button class="code-btn" type="button" @click="getCode" :disabled="isClick" :class="{noclick:isClick}">{{titibs}}</button></div>
                  <div class="one-line"><span class="email-line">姓名</span><input required v-model="inputData.name" type="text" class="email-input"></div>
                  <div class="one-line"><span class="email-line">電話</span><input required v-model="inputData.mobile" type="text" class="email-input"></div>

                <div class="col-sm-2"></div>
                <div class="footer-button1 col-xs-6 col-sm-4" type="submit"><button>完成</button></div>
                <div class="footer-button2 col-xs-6 col-sm-5" @click="colse"><button>取消</button></div>
                </form>
            </div>
        </div>
    </transiton>
</template>

<script>
export default{
  name: 'alert',
  data () {
    return {
      showAlert: false,
      titibs: '接收驗證碼',
      isError: false,
      tips: '請輸入電郵獲取驗證碼',
      isClick: false,    // 验证码是否能点击
      inputData: {}
    }
  },
  props: {
    workId: Number
  },   // 作品id
  methods: {
    // 发送验证码
    getCode: function () {
      var that = this
      const username = this.inputData.email

      if(username === undefined || username.split(" ").join("").length === 0){
        this.tips = '請填寫郵箱'
        that.isError = true
        return
      }else if(!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(username)){
        this.tips = '郵箱格式錯誤'
        that.isError = true
        return
      } else {
        that.isError = false
        this.tips = '請輸入電郵獲取驗證碼'
      }

      const data  = {username: username}
      this.$axios({
        url: '/user/verification_code/send',
        method: 'post',
        data: this.$qs.stringify(data)
      })
        .then(function (response) {
          // 验证码发送成功
          if (response.data.code === 1) {
            that.titibs = '驗證碼发送成功'
            that.isClick = true
          }else {
            that.isError = true
            that.tips = response.data.msg
          }
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    check: function () {
      var that = this
      // base64 加密投票数据
      let Base64 = require("js-base64").Base64 // 还是require
      var data = JSON.stringify(this.inputData)
      var res = Base64.encode(data)
      var theData = {'a': res}
      // console.log(res)
      this.$axios({
        url: 'activity/vote',
        method: 'post',
        data: this.$qs.stringify(theData)
      })
        .then(function (response) {
          // 投票成功
          if (response.data.code === 0) {
            that.isError = true
            that.tips = response.data.msg
            // that.$emit('voteSuccess', true)
            // that.showAlert = false
          } else {
            that.$emit('voteSuccess', true)
            that.showAlert = false
            // that.$router.push('vote-success')
            // console.log(response.data)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    show: function (workId, activityId) {
      this.inputData.form_value_id = workId
      this.inputData.activity_id = activityId
      this.showAlert = true
    },
    colse: function () {
      this.showAlert = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clearfix:after{
        display: block;
        visibility: hidden;
        clear: both;
        height: 0;
        content: ".";
    }
    .clearfix{
        zoom: 1;
    }
    .container{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.42);
        z-index: 1;
        transition: all .3s ease-in-out;
    }
    .popup{
        position: relative;
        margin: 20% auto 0;
        /*width: 434px;*/
        width: 400px;
        height: 320px;
        z-index: 5;
        background: #ffffff;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
        border-radius: 7px;
    }
    .popup .title{
        padding: 10px 20px;
        border-bottom: solid 5px #617BE4;
    }
    .popup .title span{
        font-family: PingFangSC-Medium;
        float: left;
        font-size: 20px;
        color: #565656;
        text-align: left;
    }
    .popup .title a{
        text-align: center;
        float: right;
        display: inline-block;
        line-height: 18px;
        border: 2px solid #617BE4;
        width: 25px;
        height: 25px;
        border-radius: 13px;
        color: #617BE4;
        font-size: 25px;
        text-decoration: none;
        cursor: pointer;
    }
    .popup .form{
        padding-left: 20px;
        padding-top: 5px;
    }
    .popup .form h4{
        font-family: PingFangTC-Regular;
        font-size: 16px;
        color: #9E9E9E;
        text-align: left;
    }
    .popup .form .one-line{
        text-align: left;
        margin-bottom: 15px;
    }
    .email-line{
      margin-right: 30px;
    }
    .code-line{
      margin-right: 15px;
    }
    .popup .form .one-line span{
        display: inline-block;
        font-size: 16px;
        color: #4A4A4A;
    }
    .popup .form .one-line input{
        background: #EEEEEE;
        height: 30px;
        border-radius: 100px;
        border: hidden;
        padding-left: 10px;
    }
    .popup .form .one-line .code-btn{
        font-size: 14px;
        width: 115px;
        height: 30px;
        margin-left: 5px;
        background: #F5A623;
        border-radius: 100px;
        border: hidden;
        color: #ffffff;
    }
    .email-input{
        width: 300px;
    }
    .code-input{
        width: 175px;
    }
    .popup .footer-button1 button{
        height: 30px;
        width: 120px;
        border: 2px solid #5571EC;
        border-radius: 100px;
        background: #ffffff;
    }
    .popup .footer-button2 button{
        height: 30px;
        width: 120px;
        border: 2px solid #C0C2C5;
        border-radius: 100px;
        background: #ffffff;
    }

  @media (max-width: 767px) {
    .popup{
      margin: 50% auto 0;
      width: 250px;
      height: 310px;
    }
    .popup .title{
      border-bottom: solid 3px #617BE4;
    }
    .popup .title span{
      font-size: 12px;
    }
    .popup .title a{
      line-height: 15px;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      font-size: 20px;
    }
    .email-line{
      margin-right: 15px;
    }
    .code-line{
      margin-right: 5px;
    }
    .email-input{
      width: 190px;
    }
    .code-input{
      width: 100px;
    }
    .popup .form .one-line .code-btn{
      width: 80px;
      height: 24px;
      margin-left: 5px;
      font-size: 10px;
    }
    .popup .form{
      padding-left: 10px;
    }
    .popup .form h4{
      font-size: 10px;
    }

    .popup .form .one-line span{
      font-size: 14px;
    }

    .popup .footer-button1 button{
      height: 35px;
      width: 86px;
      border-radius: 50px;
      float: right;
    }
    .popup .footer-button2 button{
      height: 35px;
      width: 86px;
      border-radius: 50px;
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/messageCode.vue